import React from 'react';
import { Typography as MuiTypography } from '@mui/material';
import { variantMapping } from './variants';

const Typography = ({
  variant = 'body1',
  color = 'inherit',
  align = 'inherit',
  gutterBottom = false,
  noWrap = false,
  children,
  textTransform = 'none',
  ...rest
}) => (
  <MuiTypography
    variant={variant}
    color={color}
    align={align}
    gutterBottom={gutterBottom}
    noWrap={noWrap}
    sx={{
      ...variantMapping[variant],
      textTransform,
    }}
    {...rest}
  >
    {children}
  </MuiTypography>
);

export default Typography;
